module.exports = __webpack_public_path__ + "static/media/DSC01466.3c726592.jpg";